// extracted by mini-css-extract-plugin
export var alternateVersion = "style-module--alternate-version--24b48";
export var alternateVersion__link = "style-module--alternate-version__link--5a8c0";